import React from 'react'
import { When } from 'react-if'
import { EpisodesHorizontalScroller } from '@/organisms/EpisodesHorizontalScroller'
import { useGuildMember } from '@/services/GuildUserService/GuildUserService'
import { ProjectType, Season } from '@/services/ProjectsService'
import { episodesToMedias } from '@/utils/EpisodeUtil/EpisodeUtil'
import { useLocale } from '@/utils/LocaleUtil'
import { getProjectTheme } from '@/utils/project-themes'
import { hasSeasonEarlyAccess } from '@/utils/users/users'
import { EpisodeGrid } from './EpisodeGrid'

export interface EpisodeSelectorProps {
  projectSlug: string
  projectName?: string
  userGroups?: { name: string }[]
  selectedSeason?: Season
  display?: 'grid' | 'carousel'
  displayDescription?: boolean
  loading?: boolean
  hasError?: boolean
  refetch?: () => void
  projectType?: ProjectType
}

export const EpisodesSelector: React.FC<EpisodeSelectorProps> = ({
  display = 'grid',
  projectSlug,
  selectedSeason,
  loading,
  hasError,
  refetch,
  displayDescription = true,
  projectName,
  userGroups,
  projectType,
}) => {
  const { locale } = useLocale()
  const projectTheme = getProjectTheme(projectSlug)
  const { guildPermissions } = useGuildMember()
  const userHasGuildEarlyAccess = guildPermissions?.hasEarlyAccess

  const hasEarlyAccess =
    hasSeasonEarlyAccess(projectTheme.watch?.seasonEarlyAccessGroup, userGroups) || userHasGuildEarlyAccess
  const medias = episodesToMedias(selectedSeason?.episodes || [], {
    hasEarlyAccess,
    displayDescription,
    projectName,
    projectType,
    locale,
  })

  return (
    <>
      <When condition={loading}>
        <div className="h-[2.25rem] w-[6.25rem] animate-pulse rounded bg-black" />
      </When>
      {display === 'grid' ? (
        <EpisodeGrid
          projectSlug={projectSlug}
          medias={medias}
          loading={loading}
          hasError={hasError}
          refetch={refetch}
          userHasEarlyAccess={hasEarlyAccess}
        />
      ) : (
        <EpisodesHorizontalScroller medias={medias} />
      )}
    </>
  )
}
